var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-group mb-4"},[(_vm.label)?_c('m-title',{attrs:{"label":_vm.label}}):_vm._e(),_c('vs-row',[_c('vs-col',{staticClass:"m-group-body",style:({
    '--division': _vm.division,
    '--grid-row-gap': _vm.rowGap,
    '--grid-column-gap': _vm.columnGap,
  })},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }